import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/tokens.css';
import App from './App';
import { aplicarPreviaFonte } from './lib/previaFonte';

// Suprimir erro inofensivo do ResizeObserver (bug do browser com React Flow)
const resizeObserverErr = window.addEventListener('error', (e) => {
  if (e.message?.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
  }
});

// Piloto de fonte (B1.11): só age com ?fonte=b|c na URL.
aplicarPreviaFonte();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);